module.exports = __webpack_public_path__ + "assets/images_base/search-icon.svg?v=3cfb57e5";